module.exports = __webpack_public_path__ + "media/Main-Page-Trade.d0e5c924.mp4";